module.exports = __webpack_public_path__ + "static/media/ico_whatsapp_white.a79009c0.svg";